import { usePathname } from "next/navigation";

import useProfileStore from "@/store/useProfileStore";
import { useQuery } from "@tanstack/react-query";
import { COOKIE_CONFIG } from "@/config";
import { getCookie } from "cookies-next";
import { useEffect, useState } from "react";
import { useProfileData } from "@/components/hooks/profile/useProfileData.hook";

const MOBILE_BREAKPOINT = 1200;

const useHeader = () => {
  const { setProfile } = useProfileStore();
  const pathname = usePathname();
  const pathTitle = pathname.split("/")[1];
  const [deviceWidth, setDeviceWidth] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isClient, setIsClient] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const { userType } = useProfileData();

  // const { data: profile } = useQuery({
  //   queryKey: ["profile"],
  //   queryFn: async () => {
  //     const response = await getProfile();
  //     setProfile(response);
  //     return response;
  //   },
  // });

  const isActive = (href: string) => {
    if (href === "/homeowner") return pathname === "/homeowner";
    if (href === "/contractor") return pathname === "/contractor";
    return pathname.startsWith(href);
  };

  // Hide hamburger menu on auth pages
  const isAuthPage =
    pathname === "/login" ||
    pathname === "/signup" ||
    pathname === "/password/forgot";

  useEffect(() => {
    // Mark as client-side and set initial values
    setIsClient(true);
    setDeviceWidth(window.innerWidth);
    setIsLoggedIn(!!getCookie(COOKIE_CONFIG.loggedIn));

    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };

    const handleAuthStateChange = () => {
      setIsLoggedIn(!!getCookie(COOKIE_CONFIG.loggedIn));
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("auth-state-changed", handleAuthStateChange as EventListener);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener(
        "auth-state-changed",
        handleAuthStateChange as EventListener
      );
    };
  }, []); // Empty dependency array ensures it runs once on mount

  return {
    pathTitle,
    // profile,
    isLoggedIn: isClient ? isLoggedIn : null,
    deviceWidth: isClient ? deviceWidth : null,
    isOpen,
    setIsOpen,
    isActive,
    isAuthPage,
    userType,
  };
};

export default useHeader;
